export const FERTILIZER_EVENT_CREATE_MODAL = 'FERTILIZER_EVENT_CREATE_MODAL';
export const FERTILIZER_EVENT_UPDATE_MODAL = 'FERTILIZER_EVENT_UPDATE_MODAL';
export const FERTILIZER_EVENT_DELETE_MODAL = 'FERTILIZER_EVENT_DELETE_MODAL';
export const FERTILIZER_EVENT_COPY_MODAL = 'FERTILIZER_EVENT_COPY_MODAL';
export const FERTILIZER_EVENTS_COMPLETE_MODAL =
    'FERTILIZER_EVENTS_COMPLETE_MODAL';
